import T, { t } from '../../common/components/T';
import { rolesMenu } from '../../common/utils/utils';
import uikit from '../../project/uikit/styles';
import email_verificated from '../../public/src/img/plugs/email_verificated.svg';
const project = require('../../scripts/configs/project.json');

export const ALERTS = {
    verify: {
        icon: email_verificated,
        title: <T textName='ALERTS-verify-title' defaultStr='Ваш e-mail успешно верифицирован!' page='/office' />,
        text: (
            <>
                <p style={uikit.mb3}>
                    <T
                        vars={{ package: 7 }}
                        textName='ALERTS-verify-text-1'
                        defaultStr='Чтобы использовать все функции сайта, необходимо приобрести один из ${package} доступных маркетинговых пакетов.'
                        page='/office'
                    />
                </p>
                <p>
                    <T
                        textName='ALERTS-verify-text-2'
                        defaultStr='Выбирайте тот, который вам подходит и становитесь официальным партнером'
                        page='/office'
                    />
                    {` «${project?.company}»`}
                </p>
            </>
        ),
        button: (
            <>
                <T textName='ALERTS-verify-button' defaultStr='Отлично!' page='/office' />
            </>
        )
    }
};

const itemMenuChild = (submenu, data, lang) => {
    const accum = [];
    if (!!submenu.length) {
        submenu.map((childItem) => {
            const id = childItem._id;
            const childrenData = [];
            data.map((itemData) => {
                if (itemData.parent === id) {
                    childrenData.push(itemData);
                }
            });

            accum.push({
                ...childItem,
                title: childItem.title[lang] || childItem.title.default,
                icon: childItem.icon || (childItem.type === 'part' ? 'menu-category' : 'menu-file'),
                name: childItem._id + '-name',
                asLink: !!childItem.link ? childItem.link : childItem._id + '_link',
                submenu: itemMenuChild(childrenData, data, lang)
            });
        });
    }
    return accum;
};

export const getItemMenu = (data, roles, lang, outerPart, translation) => {
    const menu = [];
    if (data && !!data?.length && roles && roles?.length) {
        const filtered = rolesMenu(data, roles);
        const sorted = filtered.sort((a, b) => a.order - b.order);
        const parent = sorted.find((element) => element.parent === '')?._id;

        sorted.map((item) => {
            if (item.parent === parent) {
                const id = item._id;
                const submenu = [];
                sorted.map((itemChild) => {
                    if (itemChild.parent === id) {
                        submenu.push(itemChild);
                    }
                });

                menu.push({
                    ...item,
                    title: item.title[lang] || item.title.default,
                    icon: item.icon,
                    name: item._id + '-name',
                    submenu: itemMenuChild(submenu, sorted, lang),
                    asLink: !!item.link ? item.link : item._id + '_link'
                });
            }
        });
    } else {
        return menu;
    }
    if (outerPart) {
        menu.push({
            _id: 'logout',
            activity: true,
            asLink: '/logout',
            icon: 'menu-logout',
            name: 'logout',
            roles: [],
            showAll: true,
            target: false,
            type: 'link',
            linkNative: 'Home',
            title: translation ? (
                t('logoutTitle', 'Выйти', 'all', translation)
            ) : (
                <T textName='logoutTitle' defaultStr='Выйти' page='all' />
            ),
            submenu: []
        });
    }
    return menu;
};
